import { createContext } from 'react';

export interface LuzmoDashboardListItem {
  id: string;
  name: string;
}

export interface LuzmoCredentials {
  key?: string;
  token?: string;
}

export interface LuzmoRefreshResult {
  customDashboards: LuzmoDashboardListItem[];
  dashboardIds: Record<string, string>;
  credentials: LuzmoCredentials;
}

export interface LuzmoContextType {
  customDashboards: LuzmoDashboardListItem[];
  dashboardIds: Record<string, string>;
  deleteCustomDashboard: (dashboardId: string) => Promise<boolean>;
  error: boolean;
  isLoading: boolean;
  refreshData: () => Promise<LuzmoRefreshResult>;
  credentials: LuzmoCredentials;
}

const defaultContext: LuzmoContextType = {
  customDashboards: [],
  dashboardIds: {},
  deleteCustomDashboard: async () => false,
  error: false,
  isLoading: false,
  refreshData: async () => ({
    customDashboards: [],
    dashboardIds: {},
    credentials: {},
  }),
  credentials: {},
};

const LuzmoContext = createContext<LuzmoContextType>(defaultContext);

export default LuzmoContext;
